import React, { Component } from 'react';
import { Card, List, Button, Icon } from 'antd';
import settings from 'front-settings';

import apiService, { defaultHeaders as headers } from 'services/apiService';
import UploadFile from 'components/UploadAttachment/UploadFile';

class UpdateTemplates extends Component {
  state = { documents: [] };

  async componentDidMount () {
    try {
      const { data: { results } } =
        await apiService.request('/document-template/', { headers });

      const documents = results.map(doc => ({
        endpoint: `/document-template/${doc.id}/`,
        ...doc,
        fileType: doc.fileType || 'documenttemplate',
      }));
      this.setState({ documents });
    } catch (e) {
      this.setState({ documents: [] });
    }
  }

  render () {
    return (
      <Card title="Exporter / Importer des modèles de documents">
        <List
          itemLayout="horizontal"
          dataSource={this.state.documents}
          renderItem={({ name, url, fileType, endpoint }) => (
            <List.Item>
              <List.Item.Meta
                title={<p><strong>{name}</strong></p>}
                description={(
                  <div style={{ display: 'flex' }}>
                    <Button
                      style={{ marginRight: 10 }}
                      href={`${settings.BASE_URL}${url}`}
                      target="_blank"
                    >
                      <Icon type="download" theme="outlined" /> Exporter un fichier
                    </Button>
                    <UploadFile fileType={fileType} endpoint={endpoint} method="PATCH" />
                  </div>
                )}
              />
            </List.Item>
          )}
        />
      </Card>
    );
  }
}

export default UpdateTemplates;



// WEBPACK FOOTER //
// ./src/components/Admin/UpdateTemplates/index.js